module.exports = __webpack_public_path__ + "static/media/totem1.e389d8fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/totem1.jpg
// module id = 359
// module chunks = 0